import React from 'react';
import * as Bixby from '$/core';
import './index.scss';

interface IResultsCounterProps {
  amount: number;
}

const SortFilter: React.FC<IResultsCounterProps> = props => {
  const { amount } = props;
  return <div className="results_counter">{Bixby.Utils.pluralizeStr(amount, 'Results', true)}</div>;
};

export default SortFilter;
